import styled, { css } from 'styled-components';

interface ContainerProps {
  isFilled: boolean;
  isFocuses: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #fff;
  opacity: 0.8;
  border-radius: 10px;
  //border: 1.5px solid #cbccce;
  padding: 5px 10px;
  width: 100%;
  display: flex;
  align-items: center;
  height: 46px;

  + div {
    margin-top: 8px;
  }

  div {
    width: 100%;
    position: relative;
  }

  input {
    width: 100%;
    flex: 1;
    background: transparent;
    border: 0;
    color: #18191a;
    transition-duration: 0.2s;
    padding: 0 5px;
    outline: 0;

    ::placeholder {
      color: #18191a;
    }
  }

  svg {
    margin-right: 16px;
    color: #18191a;
    transition-duration: 0.2s;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030 !important;
    `}

  ${(props) =>
    props.isFilled &&
    css`
      svg {
        color: #18191a;
      }
    `}

  ${(props) =>
    props.isFocuses &&
    css`
      color: #18191a;
      border-color: #8c8c8c !important;

      svg {
        color: #18191a;
      }
    `}
`;
